import { render } from "./SubscriptionCountdown.vue?vue&type=template&id=35bea668"
import script from "./SubscriptionCountdown.vue?vue&type=script&lang=js"
export * from "./SubscriptionCountdown.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__